import React, { useState, useCallback } from "react";
import "./Contact.css";
import { Button } from "@mui/material";
export default function Contact() {
  const [open, openModal] = React.useState(false);
  const [error, setError] = React.useState("");

  const [Last_Name, setLast_Name] = useState("");
  const [First_Name, setFirst_Name] = useState("");
  const [Email, setEmail] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Description, setDescription] = useState("");

  const submitContatForm = (e) => {
    if (!Last_Name || !First_Name || !Email || !Mobile || !Description) {
      setError("Please fill all the required fields");
    } else {
      let Submitbtn = document.getElementById("formsubmit");
      Submitbtn.click();
    }
  };

  return (
    <React.Fragment>
      <div className="container-contact-form">
        <div className="section-contact-title">
          <h2>Contact Us</h2>

          <h5 style={{ textDecoration: "underline", marginTop: "50px" }}>
            Address &nbsp; &nbsp; &nbsp;{" "}
          </h5>

          <div className="address-txt">
            <p>C - 70, Phase-|| Extension,</p>
            <p>Noida, Uttar Pradesh 201305,</p>
            <p>India</p>
          </div>

          <h5 style={{ textDecoration: "underline", marginTop: "60px" }}>
            Email Us &nbsp; &nbsp; &nbsp;{" "}
          </h5>
          <div className="address-txt">
            <p>sales@inventum.net</p>
          </div>
        </div>
        <div>
          <div className="contact-form-contact-divide">
            <div className="contact-form-inner">
              <div className="contact-card-container">
                <h2 className="getin-txt">Get in touch!</h2>
                <p
                  style={{
                    color: "#263238",
                    fontSize: "20px",
                    fontFamily: "popins",
                    fontWeight: 500,
                    textAlign: "center",
                  }}
                >
                  {" "}
                  Please Fill Information
                </p>
                <div
                  id="crmWebToEntityForm"
                  className="zcwf_lblLeft crmWebToEntityForm"
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    maxWidth: "600px",
                  }}
                >
                  <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                  />
                  <meta
                    httpEquiv="content-type"
                    content="text/html;charset=UTF-8"
                  />
                  <form
                    action="https://crm.zoho.com/crm/WebToLeadForm"
                    name="WebToLeads129652000050014022"
                    method="POST"
                    onsubmit='javascript:document.charset="UTF-8"; return checkMandatory129652000050014022()'
                    acceptCharset="UTF-8"
                  >
                    <input
                      type="text"
                      style={{ display: "none" }}
                      name="xnQsjsdp"
                      defaultValue="485a6233e33ff9469c544f480893639484d1a7e2a844f16c4c645f791586cb5c"
                    />
                    <input
                      type="hidden"
                      name="zc_gad"
                      id="zc_gad"
                      defaultValue
                    />
                    <input
                      type="text"
                      style={{ display: "none" }}
                      name="xmIwtLD"
                      defaultValue="832a349b02accc5cfad05c9d613653f4982b536e34db83bb751e0cd4480a1d40"
                    />
                    <input
                      type="text"
                      style={{ display: "none" }}
                      name="actionType"
                      defaultValue="TGVhZHM="
                    />
                    <input
                      type="text"
                      style={{ display: "none" }}
                      name="returnURL"
                      defaultValue="https://www.keylong.io/"
                    />
                    {/* Do not remove this code. */}
                    <style
                      dangerouslySetInnerHTML={{
                        __html:
                          "\nhtml,body{\n      margin: 0px;\n}\n#crmWebToEntityForm.zcwf_lblLeft {\n      width:100%;\n      padding: 25px;\n      margin: 0 auto;\n      box-sizing: border-box;\n}\n#crmWebToEntityForm.zcwf_lblLeft * {\n      box-sizing: border-box;\n}\n#crmWebToEntityForm{text-align: left;}\n#crmWebToEntityForm * {\n      direction: ltr;\n}\n.zcwf_lblLeft .zcwf_title {\n      word-wrap: break-word;\n      padding: 0px 6px 10px;\n      font-weight: bold;\n}\n.zcwf_lblLeft .zcwf_col_fld input[type=text], .zcwf_lblLeft .zcwf_col_fld textarea {\n      width: 60%;\n      border: 1px solid #c0c6cc !important;\n      resize: vertical;\n      border-radius: 2px;\n      float: left;\n}\n.zcwf_lblLeft .zcwf_col_lab {\n      width: 30%;\n      word-break: break-word;\n      padding: 0px 6px 0px;\n      margin-right: 10px;\n      margin-top: 5px;\n      float: left;\n      min-height: 1px;\n}\n.zcwf_lblLeft .zcwf_col_fld {\n      float: left;\n      width: 68%;\n      padding: 0px 6px 0px;\n      position: relative;\n      margin-top: 5px;\n}\n.zcwf_lblLeft .zcwf_privacy{padding: 6px;}\n.zcwf_lblLeft .wfrm_fld_dpNn{display: none;}\n.dIB{display: inline-block;}\n.zcwf_lblLeft .zcwf_col_fld_slt {\n      width: 60%;\n      border: 1px solid #ccc;\n      background: #fff;\n      border-radius: 4px;\n      font-size: 12px;\n      float: left;\n      resize: vertical;\n      padding: 2px 5px;\n}\n.zcwf_lblLeft .zcwf_row:after, .zcwf_lblLeft .zcwf_col_fld:after {\n      content: '';\n      display: table;\n      clear: both;\n}\n.zcwf_lblLeft .zcwf_col_help {\n      float: left;\n      margin-left: 7px;\n      font-size: 12px;\n      max-width: 35%;\n      word-break: break-word;\n}\n.zcwf_lblLeft .zcwf_help_icon {\n      cursor: pointer;\n      width: 16px;\n      height: 16px;\n      display: inline-block;\n      background: #fff;\n      border: 1px solid #c0c6cc;\n      color: #c1c1c1;\n      text-align: center;\n      font-size: 11px;\n      line-height: 16px;\n      font-weight: bold;\n      border-radius: 50%;\n}\n.zcwf_lblLeft .zcwf_row {margin: 15px 0px;}\n.zcwf_lblLeft .formsubmit {\n      margin-right: 5px;\n      cursor: pointer;\n      color: var(--baseColor);\n      font-size: 12px;\n}\n.zcwf_lblLeft .zcwf_privacy_txt {\n      width: 90%;\n      color: rgb(0, 0, 0);\n      font-size: 12px;\n      font-family: Arial;\n      display: inline-block;\n      vertical-align: top;\n      color: var(--baseColor);\n      padding-top: 2px;\n      margin-left: 6px;\n}\n.zcwf_lblLeft .zcwf_button {\n      font-size: 12px;\n      color: var(--baseColor);\n      border: 1px solid #c0c6cc;\n      padding: 3px 9px;\n      border-radius: 4px;\n      cursor: pointer;\n      max-width: 120px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.zcwf_lblLeft .zcwf_tooltip_over{\n      position: relative;\n}\n.zcwf_lblLeft .zcwf_tooltip_ctn{\n      position: absolute;\n      background: #dedede;\n      padding: 3px 6px;\n      top: 3px;\n      border-radius: 4px;word-break: break-word;\n      min-width: 100px;\n      max-width: 150px;\n      color: var(--baseColor);\n      z-index: 100;\n}\n.zcwf_lblLeft .zcwf_ckbox{\n      float: left;\n}\n.zcwf_lblLeft .zcwf_file{\n      width: 55%;\n      box-sizing: border-box;\n      float: left;\n}\n.clearB:after{\n      content:'';\n      display: block;\n      clear: both;\n}\n@media all and (max-width: 600px) {\n      .zcwf_lblLeft .zcwf_col_lab, .zcwf_lblLeft .zcwf_col_fld {\n            width: auto;\n            float: none !important;\n      }\n      .zcwf_lblLeft .zcwf_col_help {width: 40%;}\n}\n",
                      }}
                    />

                    <div className="zcwf_row">
                      <div
                        className="zcwf_col_lab"
                        style={{ fontSize: "12px", fontFamily: "Arial" }}
                      >
                        <label htmlFor="Last_Name">
                          Last Name<span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="zcwf_col_fld">
                        <input
                          type="text"
                          id="Last_Name"
                          name="Last Name"
                          maxLength={30}
                          onClick={setLast_Name}
                        />
                        <div className="zcwf_col_help" />
                      </div>
                    </div>
                    <div className="zcwf_row">
                      <div
                        className="zcwf_col_lab"
                        style={{ fontSize: "12px", fontFamily: "Arial" }}
                      >
                        <label htmlFor="First_Name">
                          First Name<span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="zcwf_col_fld">
                        <input
                          type="text"
                          id="First_Name"
                          name="First Name"
                          maxLength={30}
                          onClick={setFirst_Name}
                        />
                        <div className="zcwf_col_help" />
                      </div>
                    </div>
                    <div className="zcwf_row">
                      <div
                        className="zcwf_col_lab"
                        style={{ fontSize: "12px", fontFamily: "Arial" }}
                      >
                        <label htmlFor="Email">
                          Email<span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="zcwf_col_fld">
                        <input
                          type="text"
                          ftype="email"
                          id="Email"
                          name="Email"
                          maxLength={30}
                          onClick={setEmail}
                        />
                        <div className="zcwf_col_help" />
                      </div>
                    </div>
                    <div className="zcwf_row">
                      <div
                        className="zcwf_col_lab"
                        style={{ fontSize: "12px", fontFamily: "Arial" }}
                      >
                        <label htmlFor="Mobile">
                          Mobile<span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="zcwf_col_fld">
                        <input
                          type="text"
                          id="Mobile"
                          name="Mobile"
                          maxLength={30}
                          onClick={setMobile}
                        />
                        <div className="zcwf_col_help" />
                      </div>
                    </div>
                    <div className="zcwf_row">
                      <div
                        className="zcwf_col_lab"
                        style={{ fontSize: "12px", fontFamily: "Arial" }}
                      >
                        <label htmlFor="Description">
                          Description<span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="zcwf_col_fld">
                        <textarea
                          id="Description"
                          name="Description"
                          onClick={setDescription}
                        />
                        <div className="zcwf_col_help" />
                      </div>
                    </div>
                    {error && (
                      <div style={{ color: "red", textAlign: "center" }}>
                        {`*` + error}
                      </div>
                    )}
                    <div className="zcwf_row">
                      <div className="zcwf_col_lab" />
                      <div className="zcwf_col_fld">
                        <Button
                          style={{
                            backgroundColor: "#0047B3",
                            color: "#fff",
                          }}
                          onClick={(e) => submitContatForm(e)}
                        >
                          Submit
                        </Button>
                        <input
                          style={{ display: "none" }}
                          type="submit"
                          id="formsubmit"
                          className="formsubmit zcwf_button"
                          defaultValue="Submit"
                          title="Submit"
                        />
                        <input
                          type="reset"
                          className="zcwf_button"
                          name="reset"
                          defaultValue="Reset"
                          title="Reset"
                        />
                      </div>
                    </div>
                    {/* Do not remove this --- Analytics Tracking code starts */}
                    {/* Do not remove this --- Analytics Tracking code ends. */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
